import { Tab } from "@mui/material";
import { styled, alpha } from "@mui/system";

interface StyledTabProps {
  $isactive: boolean;
}

export const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== "$isactive",
})<StyledTabProps>(({ $isactive, theme }) => ({
  fontSize: 13,
  fontWeight: $isactive ? 700 : 500,
  width: "fit-content",
  height: "36px !important",
  minHeight: "unset !important",
  margin: "auto !important",
  color: `${
    $isactive ? theme.palette.primary.main : theme.palette.text.secondary
  } !important`,
  backgroundColor: `${
    $isactive ? alpha(theme.palette.primary.main, 0.1) : "transparent"
  } !important`,
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  stroke: `${
    $isactive ? theme.palette.primary.main : theme.palette.text.secondary
  } !important`,
  "&:hover": {
    backgroundColor: `${alpha(theme.palette.primary.main, 0.06)} !important`,
  },
}));
